/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListLegacyProductsQueryResponse,
  ListLegacyProductsQueryParams,
  ListLegacyProducts400,
} from '../../types/ListLegacyProducts'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listLegacyProducts } from '../../clients/listLegacyProducts'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listLegacyProductsQueryKey = (
  params?: ListLegacyProductsQueryParams
) => [{ url: '/api/v1/products/' }, ...(params ? [params] : [])] as const

export type ListLegacyProductsQueryKey = ReturnType<
  typeof listLegacyProductsQueryKey
>

export function listLegacyProductsQueryOptions(
  params?: ListLegacyProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listLegacyProductsQueryKey(params)
  return queryOptions<
    ListLegacyProductsQueryResponse,
    ResponseErrorConfig<ListLegacyProducts400>,
    ListLegacyProductsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listLegacyProducts(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary List products (legacy endpoint, paginated)
 * {@link /api/v1/products/}
 */
export function useListLegacyProducts<
  TData = ListLegacyProductsQueryResponse,
  TQueryData = ListLegacyProductsQueryResponse,
  TQueryKey extends QueryKey = ListLegacyProductsQueryKey,
>(
  params?: ListLegacyProductsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListLegacyProductsQueryResponse,
        ResponseErrorConfig<ListLegacyProducts400>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listLegacyProductsQueryKey(params)

  const query = useQuery(
    {
      ...listLegacyProductsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<ListLegacyProducts400>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
